const initialState = {
  fetching: false,
  fetched: false,
  all: [],
  count: 0,
  sourceCount:0,
  featuredGraph: [],
  error: null,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'DATA_FETCHING':
      state = { ...state, ...{ fetching: true } };
      break;
    case 'DATA_ERROR':
      state = { ...state, ...{ error: payload.error, fetched: true } };
      break;

    case 'DATA_FETCHED': {
      state = { ...state, ...{ all: payload, fetching: false, fetched: true } };
      break;
    }
    case 'DATA_COUNT_FETCHING':
      state = { ...state, ...{ fetching: true } };
      break;
    case 'DATA_COUNT_ERROR':
      state = { ...state, ...{ error: payload.error, fetched: true } };
      break;

    case 'DATA_COUNT_FETCHED': {
      state = { ...state, ...{ count: payload[0].count, fetching: false, fetched: true } };
      break;
    }

    case 'SOURCE_DATA_COUNT_FETCHED': {
      state = { ...state, ...{ sourceCount: payload[0].tid, fetching: false, fetched: true } };
      break;
    }

    case 'FEATURED_GRAPH': {
      state = {
        ...state,
        featuredGraph: payload,
      }
    }

    default:
      break;
  }
  return state;
};

export default reducer;



// WEBPACK FOOTER //
// ./src/app/reducers/homepage.js